
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kharaditomumbaicabs() {



    const cardData =
    {
        keyword: ' Kharadi to Mumbai Cab ',
        heading: 'Skyline Cabs: Kharadi to Mumbai Cab ',
        headingDescription: 'Skyline Cabs offers reliable and affordable Kharadi to Mumbai Cab services. Whether you’re heading to Mumbai for a business trip, a family outing, or an airport transfer, our experienced drivers and well-maintained vehicles ensure a smooth, safe, and timely journey. Enjoy hassle-free travel with transparent fares, comfortable rides, and excellent customer support. Book your Kharadi to Mumbai cab with Skyline Cabs today and travel with confidence.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Kharadi to Mumbai Cab",
      "description": "Skyline Cabs offers reliable intercity cab services from Kharadi to Mumbai. Choose from Ertiga, Innova, or Sedan for a smooth and comfortable ride with professional drivers."
    },
    {
      "name": "Kharadi to Mumbai Airport Cab",
      "description": "Book a Skyline Cab from Kharadi to Mumbai Airport for on-time and convenient airport transfers. Choose from our fleet of Ertiga, Innova, and Sedan vehicles."
    },
    {
      "name": "Kharadi to Mumbai Taxi Service",
      "description": "Skyline Cabs provides full-service taxi solutions for travelers from Kharadi to Mumbai. Enjoy safe, comfortable travel with courteous drivers and well-maintained vehicles."
    },
    {
      "name": "Kharadi to Mumbai One Way Cab",
      "description": "Need a one-way ride from Kharadi to Mumbai? Skyline Cabs offers affordable and punctual service with flexible vehicle options for your comfort."
    },
    {
      "name": "Kharadi to Mumbai International Airport Cab",
      "description": "Travel with ease from Kharadi to Mumbai International Airport with Skyline Cabs. Our service includes luggage assistance and a comfortable ride with timely drop-offs."
    },
    {
      "name": "Cab Service in Kharadi Pune",
      "description": "Skyline Cabs delivers dependable cab services in Kharadi, Pune. From local rides to intercity journeys, we ensure timely and comfortable travel."
    },
    {
      "name": "Kharadi to Andheri Cab",
      "description": "Skyline Cabs provides prompt cab services from Kharadi to Andheri, Mumbai. Ideal for business and personal travel with options like Innova and Ertiga."
    },
    {
      "name": "Kharadi to Dadar Cab Fare",
      "description": "Skyline Cabs offers affordable cab fares from Kharadi to Dadar, with no hidden charges. Book your ride now and enjoy a comfortable journey."
    },
    {
      "name": "Kharadi to Mumbai Airport Drop",
      "description": "Get timely drop-off service from Kharadi to Mumbai Airport with Skyline Cabs. Our professional drivers and clean vehicles ensure a stress-free trip."
    },
    {
      "name": "Kharadi to Mumbai Darshan Cabs",
      "description": "Explore Mumbai’s attractions with Skyline Cabs' Darshan service from Kharadi. Enjoy a full-day ride with flexible stops and a comfortable travel experience."
    },
    {
      "name": "Kharadi to Mumbai Central Cabs",
      "description": "Skyline Cabs offers cab services from Kharadi to Mumbai Central. Whether for business or leisure, we provide convenient and safe transportation."
    },
    {
      "name": "Kharadi to Dadar Cab",
      "description": "Skyline Cabs provides smooth cab rides from Kharadi to Dadar with experienced drivers and a choice of Ertiga, Innova, and Sedan cars."
    },
    {
      "name": "Chandan Nagar to Mumbai Taxi",
      "description": "Skyline Cabs offers convenient taxi services from Chandan Nagar to Mumbai. Book online for timely pickups and a comfortable travel experience."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel economically in an Ertiga with Skyline Cabs from Pune to Mumbai. Ideal for families or small groups seeking a comfortable journey."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Choose Skyline Cabs’ Innova for a luxurious and spacious ride from Pune to Mumbai. Perfect for group travel or business trips."
    },
    {
      "name": "Pune Mumbai Skyline Cabs",
      "description": "Skyline Cabs connects Pune and Mumbai with professional drivers, on-time service, and multiple cab options including Ertiga, Innova, and Sedans."
    },
    {
      "name": "Kharadi to Dadar Taxi",
      "description": "Skyline Cabs provides comfortable taxi services from Kharadi to Dadar. Book now for a reliable and smooth intercity journey."
    },
    {
      "name": "Kharadi to Mumbai Cab Service",
      "description": "Skyline Cabs delivers trusted and timely cab services from Kharadi to Mumbai. Book online for one-way, round trip, or airport drop services."
    },
    {
      "name": "Kharadi to Borivali Cab",
      "description": "Book a cab from Kharadi to Borivali with Skyline Cabs for a relaxed and on-time travel experience. Choose from a variety of vehicles."
    },
    {
      "name": "Cab Service Kharadi Pune",
      "description": "Skyline Cabs provides local and intercity cab services in Kharadi, Pune. Book Sedans, Ertiga, or Innova for your ride today."
    },
    {
      "name": "Cab in Central Kharadi Pune",
      "description": "Looking for a cab in Central Kharadi? Skyline Cabs offers professional and reliable taxi services for all destinations including Mumbai Airport."
    },
    {
      "name": "Innova Crysta on Rent in Kharadi",
      "description": "Skyline Cabs offers Innova Crysta rentals in Kharadi. Ideal for business travel or family trips with top-tier comfort and reliability."
    },
    {
      "name": "Ertiga on Rent in Kharadi",
      "description": "Rent an Ertiga in Kharadi with Skyline Cabs for a budget-friendly and spacious travel solution. Suitable for up to 6 passengers with luggage."
    },
    {
      "name": "Sedan Cab on Rent in Kharadi",
      "description": "Skyline Cabs offers Sedan car rentals in Kharadi for business and leisure travel. Book today for an affordable and smooth ride."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs is a trusted cab provider in Pune offering intercity and local services. From Kharadi to Mumbai and beyond, we ensure safe and affordable travel."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers city-wide cab services in Pune. Whether it’s Kharadi or any part of the city, we provide clean vehicles and courteous drivers."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers comfortable and timely cab service from Pune to Mumbai Airport. Choose from Innova, Ertiga, or Sedan for your ride."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs connects Pune and Mumbai with a reliable fleet and experienced drivers. Book your ride now for a smooth intercity travel experience."
    },
    {
      "name": "Cab Service in Kharadi",
      "description": "Skyline Cabs offers prompt and professional taxi services in Kharadi. We specialize in both local and outstation trips including airport transfers."
    },
    {
      "name": "Taxi Service in Chandan Nagar Pune",
      "description": "Need a taxi from Chandan Nagar? Skyline Cabs provides local and Mumbai-bound taxi services at affordable rates with well-trained drivers."
    }
  ],
  "tableData": [
    ["Kharadi to Mumbai Cab", "Kharadi to Mumbai Airport Cab"],
    ["Kharadi to Mumbai Taxi Service", "Kharadi to Mumbai One Way Cab"],
    ["Kharadi to Mumbai International Airport Cab", "Cab Service in Kharadi Pune"],
    ["Kharadi to Andheri Cab", "Kharadi to Dadar Cab Fare"],
    ["Kharadi to Mumbai Airport Drop", "Kharadi to Mumbai Darshan Cabs"],
    ["Kharadi to Mumbai Central Cabs", "Kharadi to Dadar Cab"],
    ["Chandan Nagar to Mumbai Taxi", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Pune Mumbai Skyline Cabs"],
    ["Kharadi to Dadar Taxi", "Kharadi to Mumbai Cab Service"],
    ["Kharadi to Borivali Cab", "Cab Service Kharadi Pune"],
    ["Cab in Central Kharadi Pune", "Innova Crysta on Rent in Kharadi"],
    ["Ertiga on Rent in Kharadi", "Sedan Cab on Rent in Kharadi"],
    ["Skyline Cabs Pune", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
    ["Cab Service in Kharadi", "Taxi Service in Chandan Nagar Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kharadi to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and timely cab services from Kharadi to Mumbai, ensuring you reach your destination on time, every time. Whether you are traveling for business, leisure, or an airport transfer, we prioritize your punctuality and comfort."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our well-maintained fleet of vehicles, including sedans, SUVs, and luxury cars, guarantees a comfortable ride from Kharadi to Mumbai. Enjoy ample legroom, air-conditioning, and a smooth ride that ensures a relaxing journey throughout your trip."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs employs experienced, courteous, and professional drivers who are knowledgeable about the best routes from Kharadi to Mumbai. They ensure that your journey is safe, smooth, and efficient, while prioritizing your comfort at all times."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer affordable and competitive pricing for your Kharadi to Mumbai trip, with no hidden charges or surprise fees. Skyline Cabs provides transparent fare estimates, so you’ll know exactly what to expect when booking your ride."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available around the clock, offering flexible booking times for any part of the day or night. Whether you need an early morning ride or a late-night cab, we’re always ready to ensure your trip from Kharadi to Mumbai is seamless and stress-free."
    },
    {
        "WhyChooseheading": "Variety of Vehicle Options for Every Traveler",
        "WhyChoosedescription": "From solo travelers to groups, we offer a wide range of vehicle options. Choose from budget-friendly hatchbacks, comfortable sedans, spacious SUVs, or luxury cars, all of which are maintained to provide a smooth and enjoyable experience from Kharadi to Mumbai."
    },
    {
        "WhyChooseheading": "Quick and Easy Online Booking",
        "WhyChoosedescription": "Booking a cab from Kharadi to Mumbai is simple and fast with our user-friendly online platform. Whether via our website or mobile app, you can book your ride in minutes, receive instant confirmation, and even track your cab in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel with GPS Tracking",
        "WhyChoosedescription": "Your safety is our top priority. All of our cabs are equipped with GPS for real-time tracking, and our drivers undergo thorough background checks. You can relax knowing your journey from Kharadi to Mumbai will be secure, comfortable, and hassle-free."
    }
]













    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Kharadi to Mumbai cab with Skyline Cabs?',
            answer:
                'Booking with Skyline Cabs is simple! You can book through our website, mobile app, or by calling our 24/7 customer service. Just select Kharadi as your pickup and Mumbai as your drop location.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Kharadi to Mumbai trips?',
            answer:
                'We offer hatchbacks, sedans, SUVs, and luxury vehicles. Whether you’re traveling solo, with family, or on business, Skyline Cabs has a car for every need.',
        },
        {
            id: 3,
            question: 'Is the fare fixed or will it vary?',
            answer:
                'Our Kharadi to Mumbai cab fares are fixed and transparent. The fare includes tolls, taxes, and other applicable charges, so you always know what you are paying.',
        },
        {
            id: 4,
            question: 'Do you provide both one-way and round-trip options?',
            answer:
                'Yes, Skyline Cabs offers both one-way and round-trip services. Just select your preferred travel type at the time of booking.',
        },
        {
            id: 5,
            question: 'How long is the journey from Kharadi to Mumbai?',
            answer:
                'The journey generally takes between 3 to 4 hours depending on the traffic and time of day. Our experienced drivers ensure a smooth and timely ride.',
        },
        {
            id: 6,
            question: 'Are your drivers reliable and trained?',
            answer:
                'Absolutely. All drivers are background-verified, courteous, and well-trained in long-distance travel, offering a safe and professional experience.',
        },
        {
            id: 7,
            question: 'Can I pre-schedule a cab from Kharadi to Mumbai?',
            answer:
                'Yes, you can pre-book your ride via the Skyline Cabs app or website. Advance booking is recommended for early mornings, weekends, or holiday rush.',
        },
        {
            id: 8,
            question: 'Is airport drop service available to Mumbai from Kharadi?',
            answer:
                'Yes, we offer cab services from Kharadi to both Mumbai Domestic and International Airports. Share your flight info for a punctual drop-off.',
        },
        {
            id: 9,
            question: 'Can I change or cancel my booking after confirming?',
            answer:
                'Yes, bookings can be modified or canceled easily through our app or by contacting our customer support. We offer flexible policies for your convenience.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Kharadi to Mumbai travel?',
            answer:
                'Skyline Cabs is known for its professionalism, timely service, and well-maintained fleet. From Kharadi to Mumbai, we ensure a seamless, affordable, and comfortable travel experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Aditya Kulkarni",
            rating: 5,
            review: "Skyline Cabs made my Kharadi to Mumbai journey stress-free. The driver was on time, the car was clean and spacious, and the ride was smooth. Definitely my go-to for intercity travel now!"
        },
        {
            name: "Miss. Sneha Bhandarkar",
            rating: 4,
            review: "Really happy with the cab service from Kharadi to Mumbai. Booking was easy, and the support team was helpful. I would love if they included a small refreshments kit for long trips, but otherwise it was great!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharadi to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/kharadi-to-mumbai-cab.jpg",
  "description": "Book Kharadi to Mumbai cab service with Skyline Cabs for comfortable, affordable, and safe travel. Choose AC sedans, SUVs, and get 24/7 professional service for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7926"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kharadi-to-mumbai-cab-service"
  }
};


      

      


    return (
        <div>
     <Helmet>
  <title>Kharadi to Mumbai Cab Service | AC Taxi & 24x7 Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kharadi to Mumbai cab service with Skyline Cabs for comfortable, affordable, and safe travel. Choose AC sedans, SUVs, and get 24/7 professional service for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Kharadi to Mumbai Cab Service, Cab from Kharadi to Mumbai, One-Way Taxi Kharadi to Mumbai, Round Trip Cab Kharadi to Mumbai, AC Cab Kharadi to Mumbai, SUV Taxi Kharadi to Mumbai, 24/7 Cab Booking Kharadi to Mumbai, Online Taxi Kharadi to Mumbai, Skyline Cabs Kharadi to Mumbai, Affordable Cab Service Kharadi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kharaditomumbaicabs;